"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("./../utils");

var _playBun = _interopRequireDefault(require("../playBun"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Thumbnail = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
      banner = props.banner,
      sharp = props.sharp,
      radius = props.radius,
      source = props.source,
      className = props.className,
      href = props.href,
      filedVideoList = props.filedVideoList,
      filedVideoBg = props.filedVideoBg,
      children = props.children,
      onClick = props.onClick,
      height = props.height,
      width = props.width,
      record = props.record,
      style = props.style,
      restProps = __rest(props, ["icon", "banner", "sharp", "radius", "source", "className", "href", "filedVideoList", "filedVideoBg", "children", "onClick", "height", "width", "record", "style"]);

  var _a = (0, _utils.fomateFileData)(source),
      url = _a.url,
      _b = _a.alt,
      alt = _b === void 0 ? '' : _b;

  var formatFiledVideoBg = (0, _utils.fomateFileData)(filedVideoBg).url;
  var formatFiledVideoList = (0, _utils.fomateFileData)(filedVideoList).url;
  var extendProps = (record || {}).extendProps;
  var postMessageUrl = (record === null || record === void 0 ? void 0 : record.postMessageUrl) || (restProps === null || restProps === void 0 ? void 0 : restProps.postMessageUrl);
  var importPcClassName = {};
  var importMoClassName = {};
  Object.keys(restProps || {}).forEach(function (item) {
    switch (item) {
      case 'pc':
        importPcClassName = restProps[item] || {};
        restProps.pc = null;
        break;

      case 'mo':
        importMoClassName = restProps[item] || {};
        restProps.mo = null;
        break;

      default:
        break;
    }
  }); // 判断是否使用的样式类型 -pc or mobile

  var _c = (0, _react.useState)(true),
      currentClass = _c[0],
      setCurrentClass = _c[1];

  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(setCurrentClass);
  }, []);

  var reg_video_test = function reg_video_test(str) {
    if (!str) return false;
    var reg = /.(mp4|avi|wmv|mpg|mpeg|mov|rm|ram|swf|flv|mp3|wma|rmvb|mkv)+/g;

    if (str != null) {
      return reg.test(str.toLowerCase());
    }

    return false;
  }; // 视频播放


  var click_video = function click_video() {
    if (formatFiledVideoList) {
      (0, _utils.reinitIframe)({
        filedVideoBg: formatFiledVideoBg,
        filedVideoList: filedVideoList,
        postMessageUrl: postMessageUrl
      });
    } else {
      if (!href) return;
      window.location.href = href;
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, reg_video_test(url) ? /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: (0, _classnames["default"])('flex-default-container', {// 'flex-default-container-hover': href || filedVideoList,
    })
  }, extendProps || {}, {
    onClick: click_video
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, {
      'flex-default-container_video--init': href || formatFiledVideoList,
      'flex-default-container-hover': href || formatFiledVideoList
    })
  }, /*#__PURE__*/_react["default"].createElement("video", {
    loop: true,
    muted: true,
    autoPlay: true,
    title: alt
  }, /*#__PURE__*/_react["default"].createElement("source", {
    src: url,
    type: "video/mp4"
  }))), /*#__PURE__*/_react["default"].createElement(_playBun["default"], null)) : /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: (0, _classnames["default"])('flex-default-container', {
      'flex-default-container-hover': href || formatFiledVideoList
    })
  }, extendProps || {}, {
    onClick: click_video
  }), /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref,
    style: __assign(__assign(__assign({
      background: "url(" + (url ? url : '') + ")",
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      paddingTop: height / width * 100 + "%"
    }, currentClass ? importPcClassName : importMoClassName), style || {}), !currentClass ? {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    } : {}),
    className: (0, _classnames["default"])( // 'flex-default-container__attach',
    {
      'flex-default-container_video--init': href || formatFiledVideoList,
      'flex-default-container-hover': href || formatFiledVideoList
    }, className)
  }, restProps)), formatFiledVideoList ? /*#__PURE__*/_react["default"].createElement(_playBun["default"], null) : null));
});
Thumbnail.displayName = 'TCIThumbnail';
var _default = Thumbnail;
exports["default"] = _default;